export default function PhotometrySvg() {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <path d="M66.39,10.05h-32.78c-12.99,0-23.56,10.57-23.56,23.56v32.78c0,12.99,10.57,23.56,23.56,23.56h32.78c12.99,0,23.56-10.57,23.56-23.56v-32.78c0-12.99-10.57-23.56-23.56-23.56ZM83.8,66.39c0,9.6-7.81,17.41-17.41,17.41h-32.78c-9.6,0-17.41-7.81-17.41-17.41v-32.78c0-9.6,7.81-17.41,17.41-17.41h32.78c9.6,0,17.41,7.81,17.41,17.41v32.78Z"/>
  <path d="M62.85,23.56h-25.69c-8.6,0-13.59,4.99-13.59,13.59v25.69c0,8.6,4.99,13.59,13.59,13.59h25.69c8.6,0,13.59-4.99,13.59-13.59v-25.69c0-8.6-4.99-13.59-13.59-13.59ZM72.37,62.85c0,6.35-3.17,9.52-9.52,9.52h-25.69c-6.35,0-9.52-3.17-9.52-9.52v-25.69c0-6.35,3.17-9.52,9.52-9.52h25.69c6.35,0,9.52,3.17,9.52,9.52v25.69Z"/>
  <path d="M59.64,35.29h-19.28c-3.35,0-5.06,1.71-5.06,5.06v19.28c0,3.35,1.71,5.06,5.06,5.06h19.28c3.35,0,5.06-1.71,5.06-5.06v-19.28c0-3.35-1.71-5.06-5.06-5.06Z"/>
</svg>
  );
}




